import { ROOMS } from "#constants/classOptions"

export const COLORS = {
  GRAY1: "#F7F7F7",
  GRAY2: "#E3E3E8",
  GRAY3: "#D5D5DD",
  GRAY4: "#C7C8D1",
  GRAY5: "#ABACBA",
  GRAY6: "#8F90A3",
  GRAY7: "#5C5E70",
  GRAY8: "#2E2F38",
  DISABLED: "#EBEBE4",
  TRANSPARENT: "transparent",

  theme: {
    colorBgBase: "#D88BA4",
    colorText: "#FFFFFF",
    colorBgContainer: "#D88BA4", // Background color for unselected buttons
    colorBorder: "#D88BA4", // Border color for unselected buttons
    colorPrimary: "#CA3F72",
    colorPrimaryHover: "#CA3F72",
    colorPrimaryActive: "#962951",
  },

  text: {
    WHITE: "#EEE",
    BLACK: "#222",
    DEFAULT: "#222",
  },

  rooms: {
    [ROOMS.YELLOW_ROOM]: "#FCF5CC",
    [ROOMS.GREEN_ROOM]: "#DAF7D2",
    [ROOMS.PINK_ROOM]: "#FFCFE1",
    [ROOMS.MAIN_ROOM_1]: "#C0DEF2",
    [ROOMS.PURPLE_ROOM]: "#E9D9FF",
    [ROOMS.ORANGE_ROOM]: "#FFE6C0",
    [ROOMS.BLUE_ROOM]: "#C0DEF2",
    [ROOMS.DIGITAL_ART_ROOM]: "#FFCFE1",
    [ROOMS.PORTFOLIO_ROOM]: "#E9D9FF",
    [ROOMS.PAINTING_ROOM]: "#FFE6C0",
  },

  magenta: "#C6009E",

  success: "#8BC34A",
  warning: "#FFC107",
  error: "#F44336",

  priority: {
    OK: "#8BC34A",
    SOON: "#FFC107",
    URGENT: "#F44336",
    URGENT_DONE: "#e8b4b0",
    DONE: "#8BC34A",
  },

  statuses: {
    error: "#9c2d2d",
    success: "#088745",
  },
} as const

// Legacy colors
// export const roomColors = {
//   "Yellow Room": "#D1BF00",
//   "Green Room": "#44892A",
//   "Purple Room": "#872ABA",
//   "Orange Room": "#ed7e00",
//   "Blue Room": "#398BCE",
//   "Pink Room": "#c100b8",
//   "Main Room 1": "#398BCE", // blue
//   "Main Room 2": "#1a65a2",
//   "Main Room 3": "#193d5a",
//   "Digital Art Room": "#c100b8", // pink
//   "Portfolio Room": "#a00000", // red
//   "Painting Room": "#ed7e00", // orange
//   Birthday: "darkred", // birthdays
// }
